var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("VPopup", {
    ref: "popup",
    staticClass: "bigger-video-preview-video-container",
    attrs: { "esc-close": "" },
    on: { "popup-change": _vm.onPopupChange },
    model: {
      value: _vm.showPopup,
      callback: function ($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }